import { connect } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import "antd/dist/antd.css";
import {
  Button,
  Tooltip,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Checkbox,
} from "antd";
import { EditFilled } from "@ant-design/icons";
import { authAxios } from "../utils";
import {
  createBophanxuly,
  listBophanxuly,
  // usersListURL,
  bophanxulyURL,
  usersListURLV2,
} from "../constants";
import { openNotificationWithIcon } from "./Function";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const { Search } = Input;

const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
const fetchBophanInfo = (Id) => {
  return authAxios(cookies.get("token")).get(bophanxulyURL(Id));
};
// const fetchListTeam = () => {
//     return authAxios(cookies.get('token'))
//         .get(teamListURL)
// }
const editInfo = (newData, dataOld, dataBPXuLy) => {
  var getFilterData = dataBPXuLy
    .filter((item) => item.id !== dataOld.id)
    .filter((item) => item.name === newData.tenbophan);
  if (getFilterData.length > 0) {
    openNotificationWithIcon(
      "error",
      "Cảnh báo",
      "Trùng bộ phận đã có. Yêu cầu kiểm tra lại tên bộ phận."
    );
    return false;
  }
  let config = {
    headers: {
      Accept: "application/json",
      "Content-Type": undefined,
    },
  };
  var jsonArg1 = new Object();
  jsonArg1.name = newData.tenbophan;
  jsonArg1.is_manager = newData.user_quanly;
  jsonArg1.group_email = newData.groupmail;
  jsonArg1.description = dataOld.description;
  jsonArg1.ls_member = newData.user_member; //dataOld.ls_member
  jsonArg1.is_active = newData.is_active;
  // var jsonArg2 = new Object();
  //     jsonArg2.name = '';
  // var pluginArrayArg = new Array();
  //     pluginArrayArg.push(jsonArg1);
  // pluginArrayArg.push(jsonArg2);
  // var jsonArray = JSON.parse(JSON.stringify(pluginArrayArg))
  return authAxios(cookies.get("token"))
    .put(bophanxulyURL(dataOld.id), jsonArg1, config)
    .then((res) => {
      if (res.data.error) {
        const dataError = Object.entries(res.data.error).map(([key, value]) => (
          <p>{value}</p>
        ));
        openNotificationWithIcon("error", "Lỗi", dataError);
        return false;
      }
    })
    .catch((err) => {
      openNotificationWithIcon("error", "Lỗi", err);
      return false;
    });
};
const CreateInfo = (newData, dataBPXuLy) => {
  var getFilterData = dataBPXuLy.filter(
    (item) => item.name === newData.tenbophan
  );
  if (getFilterData.length > 0) {
    openNotificationWithIcon(
      "error",
      "Cảnh báo",
      "Trùng bộ phận đã có. Yêu cầu kiểm tra lại tên bộ phận."
    );
    return false;
  }

  // var FormData = require('form-data');
  // var data = new FormData();
  // data.append('name', newData.tenbophan)
  // data.append('is_manager', newData.user_quanly)
  // data.append('group_email', newData.groupmail)
  // data.append('ls_member', newData.user_member)
  // data.append('is_active', true)
  let jsonArg1 = {};
  jsonArg1.name = newData.tenbophan;
  jsonArg1.is_manager = newData.user_quanly;
  jsonArg1.group_email = newData.groupmail;
  jsonArg1.ls_member = newData.user_member; //dataOld.ls_member
  jsonArg1.is_active = newData.is_active;

  return authAxios(cookies.get("token"))
    .post(createBophanxuly, jsonArg1)
    .then((res) => {
      if (res.data.error) {
        const dataError = Object.entries(res.data.error).map(([key, value]) => (
          <p>{value}</p>
        ));
        openNotificationWithIcon("error", "Lỗi", dataError);
        return false;
      }
    })
    .catch((err) => {
      openNotificationWithIcon("error", "Lỗi", err);
      return false;
    });
};
async function waitForBophanInfo(Id) {
  let getBophanInfo = await fetchBophanInfo(Id);
  // let listTeam = await fetchListTeam();
  // return [getBophanInfo,listTeam]
  return getBophanInfo;
}
async function waitForeditInfo(newData, dataOld, dataBPXuLy) {
  let res = await editInfo(newData, dataOld, dataBPXuLy);
  return res;
}

async function waitForCreateInfo(newData, dataBPXuLy) {
  let res = await CreateInfo(newData, dataBPXuLy);
  return res;
}
const useResetFormOnCloseModal = ({ form, visible }) => {
  const prevVisibleRef = useRef();
  useEffect(() => {
    prevVisibleRef.current = visible;
  }, [visible]);
  const prevVisible = prevVisibleRef.current;
  useEffect(() => {
    if (!visible && prevVisible) {
      form.resetFields();
    }
  }, [visible]);
};
const ModalFormCreate = ({ visible, onCancel, ls_user }) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  useResetFormOnCloseModal({
    form,
    visible,
  });

  const onFinish = (values) => {
    authAxios(cookies.get("token"))
      .get(listBophanxuly, { params: {} })
      .then((res) => {
        waitForCreateInfo(values, res.data.results)
          .then((res) => {
            if (res != false) {
              onCancelModal(true);
            }
            // if (res.data.error) {
            //     console.log(123);
            //     const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
            //     openNotificationWithIcon('error','Lỗi', dataError)
            // }
            // else {
            //    onCancelModal(true)
            // }
            setLoadingModal(false);
          })
          .catch((err) => {
            openNotificationWithIcon("error", "Lỗi", err);
          });
      })
      .catch((err) => {});
  };
  const onOk = () => {
    setLoadingModal(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingModal(false);
  };
  const onCancelModal = (value) => {
    onCancel(value);
  };
  return (
    <Modal
      title="Tạo bộ phận xử lý mới"
      visible={visible}
      okText="Lưu"
      onOk={onOk}
      onCancel={onCancelModal}
      forceRender
    >
      <Spin spinning={loadingModal}>
        <Form
          form={form}
          layout="vertical"
          name="userFormCreate"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row>
            <Col sm={10} offset={1}>
              <Form.Item
                name="tenbophan"
                label="Tên bộ phận"
                rules={[{ required: true }]}
              >
                <Input
                  placeholder="Nhập tên bộ phận"
                  maxLength={18}
                  title="Tên bộ phận không quá 18 ký tự"
                />
              </Form.Item>
            </Col>
            <Col sm={10} offset={1}>
              <Form.Item
                name="groupmail"
                label="Group mail"
                rules={[{ required: true }]}
                style={{ width: 230 }}
              >
                <Input placeholder="Nhập group mail" />
              </Form.Item>
            </Col>
            <Col sm={10} offset={1}>
              <Form.Item
                name="user_quanly"
                label="User quản lý"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  style={{ width: 200 }}
                  optionFilterProp="children"
                  // filterOption={(input, option) =>
                  //     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  // }
                  placeholder="Chọn user quản lý"
                >
                  {ls_user.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.username}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col sm={23} offset={1}>
              <Form.Item
                name="user_member"
                label="User người dùng"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  mode="multiple"
                //   style={{ width: 230 }}
                //   maxTagCount="responsive"
                  optionFilterProp="children"
                  // defaultValue= { a }
                  // filterOption={(input, option) =>
                  //     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  // }
                  placeholder="Chọn user người dùng"
                  className="select-bpxl"
                >
                  {ls_user.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.username}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

const ModalFormEdit = ({ visible, onCancel, dataBophanEdit, ls_user }) => {
  const [form] = Form.useForm();
  const [loadingModal, setLoadingModal] = useState(false);
  const [isActive, setIsActive] = useState(true);
  useResetFormOnCloseModal({
    form,
    visible,
  });
  const onFinish = (values) => {
    authAxios(cookies.get("token"))
      .get(listBophanxuly, { params: {} })
      .then((res) => {
        waitForeditInfo(values, dataBophanEdit, res.data.results)
          .then((res) => {
            // res == false ? null : onCancelModal(true)
            if (res != false) {
              onCancelModal(true);
            }
            // if (res.data.error) {
            //     console.log(123);
            //     const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
            //     openNotificationWithIcon('error','Lỗi', dataError)
            // }
            // else {
            //    onCancelModal(true)
            // }
            setLoadingModal(false);
          })
          .catch((err) => {
            openNotificationWithIcon("error", "Lỗi", err);
          });
      })
      .catch((err) => {});
  };
  useEffect(() => {
    setIsActive(dataBophanEdit.is_active);
    form.setFieldsValue({
      tenbophan: dataBophanEdit.name,
      is_active: dataBophanEdit.is_active,
      user_quanly: dataBophanEdit.is_manager,
      user_member: dataBophanEdit.ls_member,
      groupmail: dataBophanEdit.group_email,
    });
  }, [dataBophanEdit]);
  const onOk = () => {
    setLoadingModal(true);
    form.submit();
  };
  const onFinishFailed = () => {
    setLoadingModal(false);
  };
  const onCancelModal = (value) => {
    onCancel(value);
  };
  const setActive = (e) => {
    setIsActive(e.target.checked);
    form.setFieldsValue({
      is_active: e.target.checked,
    });
  };
  // let a = ls_user.filter( (d) => d.id == dataBophanEdit.is_manager ).map((item, index) =>  { return parseInt(item.id)})
  return (
    <Modal
      title="Chỉnh sửa bộ phận"
      open={visible}
      okText="Lưu"
      onOk={onOk}
      onCancel={onCancelModal}
      forceRender
      width={600}
    >
      <Spin spinning={loadingModal}>
        <Form
          form={form}
          layout="vertical"
          name="userFormEdit"
          validateMessages={validateMessages}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          //   initialValues={{
          //     ["user_quanly"]: dataBophanEdit.is_manager
          //   }}
        >
          <Row>
            <Col sm={10} offset={1}>
              <Form.Item
                name="tenbophan"
                label="Tên bộ phận"
                rules={[{ required: true }]}
              >
                <Input maxLength={18} title="Tên bộ phận không quá 18 ký tự" />
              </Form.Item>
              <Form.Item
                name="groupmail"
                label="Group mail"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col sm={10} offset={1}>
              <Form.Item
                name="user_quanly"
                label="User quản lý"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  style={{ width: 200 }}
                  optionFilterProp="children"
                  // defaultValue= { a }
                  // filterOption={(input, option) =>
                  //     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  // }
                >
                  {ls_user.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.username}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="is_active" label="Kích hoạt">
                <Checkbox
                  defaultChecked={dataBophanEdit.is_active}
                  checked={isActive}
                  onChange={(e) => setActive(e)}
                />
              </Form.Item>
            </Col>
            <Col sm={23} offset={1}>
              <Form.Item
                name="user_member"
                label="User người dùng"
                rules={[{ required: false }]}
              >
                <Select
                  showSearch
                  mode="multiple"
                  //   style={{ width: 230 }}
                  // maxTagCount='responsive'
                  //   maxTagCount={15}
                  optionFilterProp="children"
                  dropdownMatchSelectWidth={false}
                  className="select-bpxl"
                  // defaultValue= { a }
                  // filterOption={(input, option) =>
                  //     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  // }
                >
                  {ls_user.map((item, index) => (
                    <Select.Option key={index} value={item.id}>
                      {item.username}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

class Bophanxuly extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    data: [],
    total_page: "",
    pagination: { pageSize: 10 },
    idUserEdit: "",
    dataBophanEdit: "",
    ls_user: [],
  };
  componentDidMount() {
    // this.setState({loading: true});
    this.fetchListBpxl({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "id",
      typeSort: "descend",
    });
    this.fetchListUserInfo();
  }

  handleChange = (pagination, filters, sorter, extra) => {
    this.setState({ loading: true });
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
    });
    this.fetchListBpxl({
      page_size: pagination.pageSize,
      page: pagination.current,
      columnSort: sorter.field || "id",
      typeSort: sorter.order || "descend",
      search: this.state.searchKey,
      ...filters,
    });
  };
  fetchListUserInfo = (params = {}) => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(usersListURLV2, { params: params })
      .then((res) => {
        // console.log(res.data);
        this.setState({
          ls_user: res.data,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  };
  fetchListBpxl = (params = {}) => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(listBophanxuly, { params: params })
      .then((res) => {
        this.setState({
          data: res.data.results,
          loading: false,
          total_page: res.data.count,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        // if (err.response.status === 401) {
        //     this.props.history.push('/login');
        // }
      });
  };
  SearchList = (value, event) => {
    // let {sortKey, sortDirection, pageSize} = this.state;
    const pager = { ...this.state.pagination };
    pager.current = 1;
    pager.page = 1;
    this.setState({ searchKey: value, pagination: pager });
    this.fetchListBpxl({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "name",
      typeSort: "ascend",
      search: value,
    });
  };
  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };
  editInfo = (idBophan) => {
    waitForBophanInfo(idBophan).then((res) => {
      this.setState({
        idBophanEdit: idBophan,
        dataBophanEdit: res.data,
        // listTeam:res[1].data,
        visibleFormEditModal: true,
      });
    });
  };
  showCreateModal = () => {
    this.setState({ visibleFormCreateModal: true });
  };

  hideEditModal = (value) => {
    this.setState({
      idBophanEdit: "",
      visibleFormEditModal: false,
      dataBophanEdit: "",
    });
    if (value === true) {
      this.fetchListBpxl({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
      });
      openNotificationWithIcon(
        "success",
        "Thành công",
        "Cập nhật thông tin bộ phận "
      );
    }
  };

  hideCreateModal = (value) => {
    this.setState({ visibleFormCreateModal: false });
    if (value === true) {
      this.fetchListBpxl({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
      });
      openNotificationWithIcon("success", "Thành công", "Tạo mới bộ phận ");
    }
  };

  render() {
    let {
      loading,
      data,
      total_page,
      pagination,
      visibleFormEditModal,
      visibleFormCreateModal,
    } = this.state;

    const columns = [
      {
        title: "STT",
        dataIndex: "id",
        key: "index",
        render: (value, item, index) =>
          ((pagination.current || 1) - 1) * pagination.pageSize + index + 1,
        sorter: (a, b) => a.id - b.id,
        sortDirections: ["descend", "ascend", "descend"],
      },
      {
        title: "Tên bộ phận",
        dataIndex: "name",
        key: "name",
        sorter: (a) => a,
      },
      {
        title: "User quản lý",
        dataIndex: "username_manager",
        key: "username_manager",
        sorter: (a) => a,
        // render: (value, item) => this.state.ls_user.filter( (d) => d.id == value ).map((item, index) =>  { return item.username} ),
      },
      {
        title: "Trạng thái",
        dataIndex: "is_active",
        key: "is_active",
        render: (text) => (text ? "Kích hoạt" : "Khóa"),
      },
      {
        title: "Thao tác",
        key: "operation",
        render: (text, record) => (
          <Space size="middle">
            <Tooltip
              placement="bottomRight"
              title={"Chỉnh sửa thông tin bộ phận sử dụng"}
            >
              <Button onClick={() => this.editInfo(record.id)} type={"primary"}>
                <EditFilled />
              </Button>
            </Tooltip>
          </Space>
        ),
      },
    ];
    return (
      <>
        <Row>
          <Col sm={14} style={{ float: "left" }}>
            <Button
              type={"danger"}
              style={{ marginBottom: 15 }}
              onClick={this.showCreateModal}
            >
              <PlusOutlined /> Thêm bộ phận mới
            </Button>
          </Col>
          <Col sm={10} style={{ float: "right" }}>
            <Search
              placeholder="Nhập từ khóa tìm kiếm"
              enterButton="Tìm kiếm"
              size="normal"
              onSearch={this.SearchList}
            />
          </Col>
        </Row>
        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          rowKey="id"
          onChange={this.handleChange}
          pagination={{
            current: this.state.pagination.current,
            pageSize: this.state.pagination.pageSize,
            total: total_page,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "15", "25", "50"],
          }}
        />
        <ModalFormEdit
          visible={visibleFormEditModal}
          onCancel={this.hideEditModal}
          dataBophanEdit={this.state.dataBophanEdit}
          ls_user={this.state.ls_user}
        />
        <ModalFormCreate
          visible={visibleFormCreateModal}
          onCancel={this.hideCreateModal}
          ls_user={this.state.ls_user}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};
export default connect(mapStateToProps)(Bophanxuly);
